/**
 * Apply browser tab title + favicon from BE branding (no rebuild).
 */
export const applyPortalBranding = ({
  portalTitle,
  faviconUrl,
  portalLogo,
} = {}) => {
  const title = String(portalTitle || "").trim();
  if (title) {
    document.title = title;
  }

  const iconUrl = String(faviconUrl || portalLogo || "").trim();
  if (!iconUrl) {
    return;
  }

  const setLink = (rel) => {
    let link = document.querySelector(`link[rel='${rel}']`);
    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = iconUrl;
  };

  setLink("icon");
  setLink("shortcut icon");
  setLink("apple-touch-icon");
};
